<template>
  <li class="lstCheckout__item" :class="{'lstCheckout__item--limit': (self.errorClass && !expired)}">
    <div class="mask" v-if="showMask" @click="hideAllModals"></div>

    <div class="header">
      <div class="alert-stack">
        <div class="alert" v-if="!expired">
          <p>Você já atingiu seu limite de envios. <a href="/painel/gerenciar/documentos">Clique aqui</a> e aumente seu limite de forma fácil e segura!</p>
          <a href="javascript:;" class="closeAlert" @click="closeAlert"><svg class="ico"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>

        <div class="alert" style="display: block" v-if="expired">
          <p>Etiqueta Expirada</p>
        </div>
      </div>

      <div class="inputBox" v-if="!expired">
        <input type="checkbox" class="customCheck--2"
          :name="'select-' + _uid"
          :id="'select-' + _uid"
          :ticket-id='ticketId'
          :checked="isSelected"
          @change="change($event, ticketId)"
        >
        <label :for="'select-' + _uid"><!-- --></label>
      </div>

      <img class="logo" :src="self.service.company.picture" :alt="self.service.company.name" :title="self.service.company.name">
      <div v-if="isReverseLogistic" class="tag tag--primary">
        <strong>MODALIDADE:</strong> Logística Reversa
      </div>
      <template v-else>
        <p class="txt"><strong>Modalidade:</strong> {{ self.service.name }}</p>
        <p class="txt"><strong>Código de envio:</strong> {{ self.protocol }}</p>
      </template>

      <p class="txt" v-if="self.agency"><strong>Agência:</strong> {{ self.agency.name }}</p>

      <a href="javascript:;" class="removePackage" @click="$parent.removeItem(index)"><svg class="ico"><use xlink:href="/images/svg-symbols.svg#trash"></use></svg></a>
    </div>
    <div class="package">
      <ul class="packageList packageList--checkout">
        <li class="packageList__item">
          <strong class="ttl">Volumes</strong>
          <div class="content">
            <p><strong>Dimensões:</strong></p>
            <div v-for="(item, volKey) in groupVolumes.slice(0,3)" :key="volKey">
              <p>
                <span v-show="groupVolumes.length > 1">{{transformNumberToAlphabet(volKey)}}| </span>{{ item.times }} Qtd. x
                {{ item.height }}cm A X
                {{ item.width }}cm L X
                {{ item.length }}cm C X
                {{ item.weight }}Kg
              </p>
            </div>
            <div v-if="groupVolumes.length > 3">
              <a href="javascript:;" class="editDeclaracao__link" @click="$refs['modalV2ViewVolumes'].open()">Ver volumes</a>
            </div>
            <div :class="['diminishable-content', {'diminishable-content--open': showAllInformations}]">
              <p><strong>Valor Segurado:</strong> {{ self.insurance_value | currency }}</p>
              <p><strong title="Aviso de recebimento">A.R.:</strong> {{ self.receipt | prettyBool }}</p>
              <p><strong>Mão Própria:</strong> {{ self.own_hand | prettyBool }}</p>
              <p><strong>Coleta:</strong> {{ self.collect | prettyBool }}</p>
              <p><strong>Data:</strong> {{ self.created_at | pretty_datetime }}</p>
            </div>
            <p v-if="expirationMessage" class="mui-text-danger"><strong>{{expirationMessage}}</strong></p>
            <p v-if="self.tags && self.tags.length"><strong>Tags:</strong> {{ self.tags.map((e) => e.tag).join(', ') }}</p>
          </div>
        </li>

        <li class="packageList__item">
          <strong class="ttl">Prazo</strong>
          <div class="content">
            <p>{{ delivery }}</p>
          </div>
        </li>

        <li class="packageList__item">
          <strong class="ttl">Remetente</strong>
          <div class="content">
            <p>{{ self.from.name }}</p>
            <div :class="['diminishable-content', {'diminishable-content--open': showAllInformations}]">
              <p>CEP: {{ self.from.postal_code | postal_code }}</p>
              <p>Endereço: {{ self.from.address }}, {{ self.from.location_number }}<template v-if="self.from.complement"> {{ self.from.complement }}</template></p>
              <p>{{ self.from.district }} - {{ self.from.city }}/{{ self.from.state_abbr }}</p>
            </div>
          </div>
        </li>

        <li class="packageList__item">
          <strong class="ttl">Destinatário</strong>
          <div class="content">
            <p>{{ self.to.name }}</p>
            <div :class="['diminishable-content', {'diminishable-content--open': showAllInformations}]">
              <p v-if="self.to.email" class="break-word">E-mail: {{ self.to.email }}</p>
              <p>CEP: {{ self.to.postal_code | postal_code }}</p>
              <p>Endereço: {{ self.to.address }}, {{ self.to.location_number }}<template v-if="self.to.complement"> {{ self.to.complement }}</template></p>
              <p>{{ self.to.district }} - {{ self.to.city }}/{{ self.to.state_abbr }}</p>
            </div>
          </div>
        </li>

        <li class="packageList__item">
          <strong class="ttl">Preço</strong>
          <div class="content">
            <p class="price price--blue">{{ self.quote | currency }}</p>
          </div>
        </li>

        <li class="packageList__item">
          <strong class="ttl"></strong>
          <div class="content">
            <ion-icon
              :class="['arrow-icon', 'md', 'hydrated', {'arrow-icon--open': showAllInformations}]"
              name="chevron-down-outline"
              @click="toggleInformationsVisibility"
            ></ion-icon>
          </div>
        </li>
      </ul>
    </div>
    <div class="editDeclaracao" v-if="canShowEditDeclarationContentButton">
      <a href="javascript:;" class="editDeclaracao__link" @click="startEditDeclaration">Editar declaração de conteúdo</a>
    </div>

    <div class="coupon-section">
      <div>
        <ion-icon class="coupon-section__icon--ticket" name="ticket-outline"></ion-icon>
        <span>Possui cupom de desconto?</span>
      </div>
      <div class="coupon-section__coupon-line" v-if="self.coupon">
        <div class="coupon-section__applyed-coupon">
          <span>{{self.coupon.coupon}}</span>
          <ion-icon
            class="coupon-section__icon--close"
            name="close-outline"
            @click="removeCouponValue"
          ></ion-icon>
          <span
            v-if="self.coupon"
            class="tooltip tooltip--right tooltip--right-to-left tooltip--blue -cartCoupon"
            :data-tooltip="`Este cupom lhe garante ${coupon_value} de desconto sobre o valor de uma etiqueta.`"
          >
            <i>?</i>
          </span>
        </div>
        <div class="totalPrice">
          <p class="price price--red price--negative price--coupon">{{ coupon_value }}</p>
        </div>
      </div>
      <template v-else>
        <select
          v-if="hasCoupon"
          v-model="self.selectedCoupon"
          class="coupon-section__select"
        >
          <option value="" selected hidden disabled>Selecione</option>
          <option
            v-for="coupon in $parent.coupons"
            :key="coupon.coupon.coupon"
            :value="coupon.coupon.coupon"
          >
            {{coupon.coupon.coupon}}
          </option>
        </select>
        <div class="coupon-section__add-coupon">
          <input
            v-model="coupon"
            class="form-control coupon-section__input"
            placeholder="Digite o código do seu cupom de desconto"
            type="text"
          />
          <button
            class="btnBorder btnBorder--small"
            @click="confirmAddCoupon"
          >
            Adicionar
          </button>
        </div>
      </template>
    </div>


    <div class="finalPrice">
      <div class="boxText">
        <p class="txt">Preço final:</p>
      </div>
      <div class="totalPrice">
        <p class="price price--blue">{{ self.price | currency }}</p>
      </div>
    </div>

    <transition name="fade">
      <div class="modal -blue -declaration -scrollCenter" v-if="modalEditDeclaration">
        <div class="modal__header">
          <p>Editar declaração</p>
          <a href="javascript:;" class="closeModal"><svg class="ico" @click="discardEditDeclaration"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>
        <div class="modal__content" v-bind:style="{ 'max-height': modalHeight + 'px' }">
          <div class="formEtiqueta">
            <div class="form">
              <ul class="lstDeclaracao">
                <declaration-item
                  ref='declaration-item'
                  v-for="(item, index) in products"
                  :key="item.id"
                  :size="products.length"
                  :index="index"
                  :companyId="self.service.company.id"
                  :insuranceValue="self.insurance_value"
                  :serviceMaxInsuranceValue="serviceMaxInsuranceValue"
                  @remove="removeItem(index)"
                />
              </ul>

              <div v-if="!isLoggiService(self.service_id)">
                <a href="javascript:;" class="btnAddMore -declaracao" @click="addMore">
                  <span class="ico">
                    <span></span><span></span>
                  </span>
                  <span class="txt">Adicionar +1 produto</span>
                </a>
              </div>
            </div>
          </div>
          <NotificationTag
            v-if="isDeclarationTotalValueDifferentFromInsurance"
            class="modal-notification-alert"
            :canClose="false"
            type="danger"
            withIcon
          >
            <div class="text-base">
              <p class="mb-4">Por favor, confirme o valor da declaração antes de prosseguir.</p>
              <p>O valor total dos itens que você está declarando deve ser <strong class="font-bold">igual ao valor do seguro de {{ self.insurance_value | currency }}</strong> informado na cotação.</p>
            </div>
          </NotificationTag>
        </div>
        <div class="modal__footer">
          <button name="Tentar novamente" type="button" class="btnBorder btnBorder--small" :disabled="isDeclarationTotalValueDifferentFromInsurance" @click="editDeclaration()"><span>Ok</span></button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal modal--small modal--center" v-if="modalAlert">
        <div class="modal__header">
          <p>{{ modalAlertHeader }}</p>

          <a href="javascript:;" class="closeModal"><svg class="ico" @click="hideModal('modalAlert')"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>
        <div class="modal__content">
          <p>{{ modalAlertText }}</p>
        </div>
        <div class="modal__footer">
          <button
            type="button"
            name="action"
            class="btnBorder btnBorder--small"
            :title="modalAlertButtonText"
            @click="hideModal('modalAlert')"
          >
            <span>{{modalAlertButtonText}}</span>
          </button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <VolumesModal ref="modalV2ViewVolumes" :volumes="groupVolumes" />
    </transition>
  </li>
</template>

<script>
  import moment from 'moment';
  import { nanoid } from 'nanoid';

  import Alphabet from 'commons/js/Alphabet';
  import date from 'commons/js/formatters/Date';
  import leftPad from 'commons/js/LeftPad';
  import ShippingDefinitions from 'commons/js/ShippingDefinitions';
  import { ORDER_MODALITIES } from 'commons/js/enums/orders';

  import DeclarationItem from 'commons/js/components/calculator/Declaration-item';
  import NotificationTag from 'commons/js/components/atoms/NotificationTag';
  import VolumesModal from 'commons/js/components/modals/VolumesModal';
  import { validateDeclarationFields } from 'commons/js/components/forms/services/CommonFormServices';

  export default {
    mixins: [ShippingDefinitions],

    components : {
      NotificationTag,
      VolumesModal,
      'declaration-item': DeclarationItem
    },

    props : {
      index: {
        type: Number,
        required: true
      },

      ticketId: {
        type: String,
        required: true
      },

      isSelected: {
        type: Boolean,
        required: true
      },

      expirationDate: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        addCoupon: false,
        coupon: '',
        loaded: false,
        original: {
          name: '',
          quantity: '',
          unitary_value: '',
          focus: {
            name: false,
            quantity: false,
            unitary_value: false
          },
        },

        products: [],
        uneditedProducts: [],

        showMask: false,
        modalEditDeclaration: false,
        modalAlert: false,
        modalAlertHeader: 'Atenção!',
        modalHeight: 9999,
        modalAlertText: '',
        modalAlertButtonText: 'Tentar novamente',
        modalViewVolumes: false,

        showAllInformations: false
      }
    },

    watch: {
      'self.selectedCoupon'(value) {
        if (value) {
          value = String(value).trim().toUpperCase();
          const coupons = this.$parent.coupons.filter((e) => e.coupon.coupon === value);
          this.applyCouponValue(coupons[0].coupon);
          this.coupon = '';
        }
      }
    },

    computed: {
      self() {
        let item = this.$parent.items[this.index];
        return item;
      },
      coupon_value() {
        if (!this.self.coupon) {
          return 'R$ 0,00';
        }
        if (this.self.coupon.percent) {
          return this.self.coupon.value + '%';
        }
        return 'R$ ' + Number(this.self.coupon.value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      delivery() {
        if (!this.self) return '-';

        return `${this.self.delivery_min} ${this.self.delivery_min > 1 ? `dias úteis` : `dia útil`} a partir da data de postagem`;
      },
      coupons() {
        return this.$parent.coupons.map((coupon) => {
          return {
            value: coupon.coupon.coupon, text: coupon.coupon.coupon
          };
        }).sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
      },
      groupVolumes() {
        const volumesGroup = this.self.volumes.reduce((a, b) => {
          const i = a.findIndex(x => x.height === b.height && x.length === b.length && x.weight === b.weight && x.width === b.width);
          return i === -1 ? a.push({
            ...b,
            times: 1
          }) : a[i].times++, a;
        }, []);
        return volumesGroup;
      },
      expired() {
        return !!this.expirationDate && date.isDateAfter(this.localExpirationDate);
      },
      canShowEditDeclarationContentButton() {
        return this.canEditDeclaration(this.self.service.company.id) && !this.self.invoice;
      },
      serviceMaxInsuranceValue() {
        const serviceRestrictions = this.self.service.restrictions && JSON.parse(this.self.service.restrictions);

        const maxInsuranceValue = serviceRestrictions.insurance_value && serviceRestrictions.insurance_value.max;

        return +maxInsuranceValue || 50000;
      },
      /**
       * Returns if the order is reverse logistic
       * @returns {boolean}
       */
      isReverseLogistic() {
        return this.self.reverse === ORDER_MODALITIES.REVERSE_LOGISTIC;
      },

      hasCoupon() {
        return this.$parent.coupons.filter((e) => e.times > 0).length > 0 || this.self.coupon;
      },

      declarationTotalValue() {
        return this.products.reduce((acc, product) => ((this.decimalValue(product.unitary_value) * product.quantity) + acc), 0);
      },

      isDeclarationTotalValueDifferentFromInsurance() {
        return (this.self.insurance_value > 0) && (this.declarationTotalValue > 0) && (this.declarationTotalValue !== this.self.insurance_value);
      },

      localExpirationDate() {
        return !!this.expirationDate && date.getLocalDate(this.expirationDate);
      },

      expirationMessage() {
        if (this.expired) return 'Expirada';

        const expiresIn = date.addTime(
          date.getLocalDate(this.self.created_at),
          MEConfig.get('expiration_days.in_cart'),
          'days'
        );

        if (date.isDateBefore(expiresIn)) {
          return `Expira ${date.getRelativeTime(expiresIn)}`;
        };

        return false;
      }
    },

    filters: {
      postal_code(value) {
        return leftPad(String(value).replace(/\D/g, ''))
          .replace(/^(\d{5})(\d{3})$/, '$1-$2');
      },
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      decimal(value) {
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        return Number(value).toLocaleString();
      },
      prettyBool(value) {
        return Boolean(Number(value)) ? 'Sim' : 'Não';
      },
      pretty_datetime(value) {
        if (!value) return '-';
        let date = new Date(String(value).replace(/\s/, 'T') + '.00Z');
        return date.toLocaleString();
      }
    },

    created() {
      if (this.self.coupon) {
        let contains = this.$parent.coupons.filter((e) => {
          return e.coupon.coupon === this.self.coupon.coupon;
        }).length > 0;
        if (!contains) {
          this.$parent.coupons.push({
            coupon: this.self.coupon,
            times: 0
          });
        }
      }

      this.self.products.forEach((product) => {
        this.products.push({
          id: nanoid(),
          name: product.name,
          quantity: product.quantity,
          unitary_value: product.unitary_value,
          focus: {
            name: false,
            quantity: false,
            unitary_value: false
          }
        });
      });
    },

    methods: {
      calculateExpireTime (date) {
        const days = MEConfig.get('expiration_days.in_cart');
        const expiresIn = moment(date).add(days, 'day')
        const today = moment()

        const timeMoments = [
          {
            name: 'dia(s)',
            pattern: 'days'
          },

          {
            name: 'hora(s)',
            pattern: 'hours'
          },

          {
            name: 'minutos',
            pattern: 'minutes'
          }
        ]

        const payload = {
          expired: false,
          message: ''
        }

        let diff;

        timeMoments.some(item => {
          diff = expiresIn.diff(today, item.pattern)

          if (diff !== 0 && item.pattern !== 'minutes') {
            payload.message = `${diff} ${item.name}`

            if (diff < 0) {
              payload.expired = true
              payload.message = 'Expirada'
            }

            return true
          }

          payload.message = 'Em menos de uma hora';
        })

        return payload
      },
      startEditDeclaration() {
        this.uneditedProducts = JSON.parse(JSON.stringify(this.products));
        this.showModal('modalEditDeclaration', true);
      },
      discardEditDeclaration() {
        this.hideModal('modalEditDeclaration');
        this.products = JSON.parse(JSON.stringify(this.uneditedProducts));
      },
      editDeclaration() {
        // Validate all declaration fields
        const refs = this.$refs['declaration-item'];
        const isDeclarationValid = validateDeclarationFields(refs);

        if(!isDeclarationValid) return;

        // send
        this.$parent.loading = true;

        axios.post('/api/v2/me/orders/' + this.self.id + '/products', {
          products: this.products.map((e) => {
            return {
              name: e.name,
              quantity: e.quantity,
              unitary_value: this.decimalValue(e.unitary_value),
            };
          })
        }).then(({data}) => {
          this.products = [...data.products];
          this.$parent.loading = false;
          this.hideModal('modalEditDeclaration');
        }).catch(() => {
          this.$parent.loading = false;
          this.hideModal('modalEditDeclaration');
        });
      },
      decimalValue(value) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        return parseFloat(value);
      },
      removeCouponValue() {
        if (!this.self.coupon) {
          return;
        }
        this.$parent.loading = true;
        axios.put('/api/v2/me/coupon/' + this.self.id).then((response) => {
          setTimeout(() => {
            this.$parent.loading = false;
          }, 3000);
          this.$parent.loadCoupons();
        }).catch((error) => {
          setTimeout(() => {
            this.$parent.loading = false;
            if (error.response.data && error.response.data.error) {
              this.showModal('modalAlert');
              this.modalAlertText = error.response.data.error;
            } else {
              this.showModal('modalAlert');
              this.modalAlertText = 'Erro ao remover Cupom';
            }
          }, 3000); // cache lock
        });
        if (this.self.coupon.percent) {
          this.self.price = Math.max(Math.round((this.self.price /  (1 - this.self.coupon.value / 100)) * 100) / 100, 0);
        } else {
          this.self.price = Math.max(Math.round((this.self.price + this.self.coupon.value) * 100) / 100, 0);
        }
        this.self.coupon = null;
        this.self.selectedCoupon = '';
      },
      applyCouponValue(coupon) {
        this.$parent.loading = true;
        localStorage.setItem('price'+this.self.id, this.self.price);
        axios.put('/api/v2/me/coupon/' + this.self.id, {
          coupon: coupon.coupon
        }).then((response) => {
            setTimeout(() => {
              this.$parent.loading = false;
              if (response.headers['x-locked']) {
                this.showModal('modalAlert');
                this.modalAlertText = 'Favor aguardar 3 segundos para inserir o cupom.';
                return;
              }
              this.$parent.loadCoupons();
              if (response.data && response.data.coupon && response.data.coupon.coupon === coupon.coupon) {
                this.self.coupon = coupon;
                this.self.price = response.data.price;
                this.modalAlertHeader = 'Sucesso!'
                this.modalAlertText = 'Cupom de desconto adicionado com sucesso.';
                this.modalAlertButtonText = 'Entendi';

                this.$nextTick(() => {
                  this.showModal('modalAlert');
                });
              } else {
                this.showModal('modalAlert');
                this.modalAlertText = 'Erro ao aplicar Cupom';
              }
            }, 3000); // cache lock
          })
          .catch((error) => {
            setTimeout(() => {
              this.$parent.loading = false;
              if (error.response.data && error.response.data.error) {
                this.showModal('modalAlert');
                this.modalAlertText = error.response.data.error;
              } else {
                this.showModal('modalAlert');
                this.modalAlertText = 'Erro ao remover Cupom';
              }
            }, 3000); // cache lock
        });
      },
      confirmAddCoupon() {
        let coupon = String(this.coupon).trim().toUpperCase();
        if (!coupon) {
          return;
        }
        let contains = this.$parent.coupons.filter((e) => {
          return e.coupon.coupon === coupon && e.times > 0;
        }).length > 0;
        if (contains) {
          this.coupon = '';
          this.self.selectedCoupon = coupon;
          this.addCoupon = false;
          return;
        }
        axios.post('/api/v2/me/coupons', {
          coupon: coupon
        }).then((response) => {
          if (response.data) {
            this.self.selectedCoupon = coupon;
            this.$parent.coupons.push(response.data);
            this.coupon = '';
            this.addCoupon = false;
          }
        }).catch((error) => {
          if (error.response.data.error) {
            this.showModal('modalAlert');
            this.modalAlertText = error.response.data.error;
          } else {
            this.showModal('modalAlert');
            this.modalAlertText = 'Este cupom é inválido';
          }
        });
      },
      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
        if (scroll) {
          this.modalHeight = window.innerHeight - 210;
        }
      },
      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
      },
      hideAllModals() {
        this.showMask = false;
        this.modalAlert = false;
        this.modalEditDeclaration = false;
        this.modalViewVolumes = false;
      },
      change({target: {checked}}, id) {
        this.$emit('on-update-ticket', {checked, id});
      },
      closeAlert() {
        this.self.errorClass = false;
      },
      addMore() {
        this.products.push(JSON.parse(JSON.stringify({id: nanoid(), ...this.original})));
      },
      removeItem(index) {
        this.products.splice(index, 1);
      },
      transformNumberToAlphabet(number) {
        return Alphabet(number);
      },

      toggleInformationsVisibility() {
        this.showAllInformations = !this.showAllInformations;
      }
    }
  };
</script>
